import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Add14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M7.75 6.25V1H6.25V6.25H1V7.75H6.25V13H7.75V7.75H13V6.25H7.75Z'
      fill='currentColor'
    />
  </Svg>
);

Add14.displayName = 'Add14';
export default Add14;
